import { lazy, Suspense } from 'react';

import ErrorBoundary from '@apigrowfinance/pbolt-error-boundary';
import GlobalLoader from '@apigrowfinance/pbolt-global-loader';
import { FormattedMessage } from 'react-intl';

const CardsApp = lazy(() => import('./CardsApp'));

const SuspendedCardsApp = () => (
    <ErrorBoundary
        title={
            <FormattedMessage
                id="suspendedCardsApp.errorTitle"
                defaultMessage="An Error Occurred"
            />
        }
        message={
            <FormattedMessage
                id="suspendedCardsApp.error"
                defaultMessage="Failed to load Cards application"
            />
        }>
        <Suspense fallback={<GlobalLoader />}>
            <CardsApp />
        </Suspense>
    </ErrorBoundary>
);

export default SuspendedCardsApp;
